import { client } from "../client.ts";
import { WORKSPACE_HEADER_NAME } from "@sg-protect/core";
import type { Session } from "../types.ts";

export async function fetchSession(workspaceId?: string): Promise<Session> {
    const { data, error } = await client.GET("/bff/session", {
        headers: workspaceId ? { [WORKSPACE_HEADER_NAME]: workspaceId } : undefined
    });

    if (error) {
        throw new Response(null, { status: 500, statusText: "Failed to fetch session" });
    }

    return data;
}
